import axios from 'axios'
import moment from 'moment'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'
import config from '../../../config'

export async function postCentralPeopleFlow(condition = {}) { // 取得起訖時間內，景區時間單位內的車流
  let response = {}

  if(Utils.isEmptyObject(condition) || Utils.isEmptyObject(condition.sttime) || Utils.isEmptyObject(condition.endtime) || 
      Utils.isEmptyObject(condition.interval) || !Array.isArray(condition.areas)) {
    console.log('iisi postCentralPeopleFlow: condition error')
    return {}   
  }

  try {
    response = await axios.post(`${config.eastCoastDataApi()}PeopleFlowElk/CentralPeopleFlow`, condition)

  } catch (err) {
    console.error('iisi postCentralPeopleFlow: ', err)
    return {}
  }

  Utils.setApiResponsSuccess(response)
  return response
}

export async function postToiletPeopleFlow(condition = {}) {
  let response = {}

  if(Utils.isEmptyObject(condition) || Utils.isEmptyObject(condition.sttime) || Utils.isEmptyObject(condition.endtime) || 
      Utils.isEmptyObject(condition.interval) || !Array.isArray(condition.areas) || !Array.isArray(condition.toilets)) {
    console.log('iisi postToiletPeopleFlow: condition error')
    return {}   
  }

  try {
    response = await axios.post(`${config.eastCoastDataApi()}PeopleFlowElk/ToiletPeopleFlow`, condition)

  } catch (err) {
    console.error('iisi postToiletPeopleFlow: ', err)
    return {}
  }

  Utils.setApiResponsSuccess(response)
  return response
}